/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, string, arrayOf, number, bool,  array, func,
} from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ReactMarkDown from 'react-markdown';
import loadable from '@loadable/component';

const SpecialRadioOffers = loadable(() => import(/* webpackChunkName: "SpecialRadioOffers" */ './SpecialRadioOffers'));
const RadioOfferProductList = loadable(() => import(/* webpackChunkName: "RadioOfferProductList" */ './RadioOfferProductList'));
const GraphqlLeftMenuContainer = loadable(() => import(/* webpackChunkName: "GraphqlLeftMenuContainer" */ '../../GraphqlCategoryPage/Partials/GraphqlLeftMenuContainer/GraphqlLeftMenuContainer'));

const useStyles = makeStyles((theme) => ({
    container: {
        maxWidth: 1440,
        boxSizing: 'border-box',
        margin: '0 auto 25px',
        padding: '0 5px',
        '& img': {
            maxWidth: '100%',
        },
    },
    bannerContainer: {
        textAlign: 'center',
        margin: '15px',
        paddingRight: '10px',
        borderRight: `1px solid ${theme.palette.grey10}`,
    },
    copyContainer: {
        padding: '10px',
        '& p': {
            fontSize: 18,
        },
    },
    bestSellerHeading: {
        background: theme.palette.radioOfferBestSellerBgColor,
        padding: '8px 18px',
        fontSize: '21px',
        margin: '15px 0px',
        color: theme.palette.radioOfferBestSellerTextColor,
        fontWeight: 700,
    },
    specialOfferTitle: {
        color: theme.palette.white,
        fontSize: '21px',
        padding: '10px',
    },
    specialOfferContainer: {
        backgroundColor: theme.palette.radioOfferBgColor,
        borderBottom: `5px solid ${theme.palette.radioOfferBgColor}`,
        margin: '5px 0 0',
    },

    leftMenu: {
        width: '100%',
        position: 'relative',
        margin: '15px 0',
        [theme.breakpoints.up(599)]: {
            width: '31.5%',
        },
        [theme.breakpoints.up(768)]: {
            width: '260px',
            position: 'relative',
        },
    },
    productContainer: {
        width: '100%',
        [theme.breakpoints.up(769)]: {
            width: ' calc(100% - 290px)',
            marginLeft: '30px',
        },
    },
    simpleProduct4Row: {
        boxSizing: 'border-box',
        flex: '0 0 25%',
        marginBottom: 10,
        maxWidth: '25%',
        position: 'relative',
        width: '100%',
        paddingRight: '10px',
        paddingLeft: '10px',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '50%',
            flex: '0 0 50%',
        },
    },
    simpleProduct5Row: {
        boxSizing: 'border-box',
        flex: '0 0 20%',
        marginBottom: 10,
        maxWidth: '20%',
        position: 'relative',
        width: '100%',
        paddingRight: '10px',
        paddingLeft: '10px',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '20%',
            flex: '0 0 20%',
        },
    },
    simpleProduct3Row: {
        boxSizing: 'border-box',
        flex: '0 0 33%',
        marginBottom: '30px',
        maxWidth: '33%',
        position: 'relative',
        width: '100%',
        paddingRight: '10px',
        paddingLeft: '10px',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '33.33%',
            flex: '0 0 33.33%',
        },
    },
    simpleProduct2Row: {
        boxSizing: 'border-box',
        flex: '0 0 50%',
        marginBottom: '30px',
        maxWidth: '50%',
        position: 'relative',
        width: '100%',
        paddingRight: '10px',
        paddingLeft: '10px',
    },

}));

const RadioOffersResultDesktopPage = ({
    mainCollection,
    data,
    featureCollection,
    listenerFavorites,
    loadComponent,
    showLeftRailContent,
    blocksData,
    bottomBanner,
    productPerRowDesktop,
}) => {
    const classes = useStyles();
    const productPerRow = (rowNumber) => {
        switch (rowNumber) {
            case 5:
                return classes.simpleProduct5Row;
            case 4:
                return classes.simpleProduct4Row;
            case 3:
                return classes.simpleProduct3Row;
            case 2:
                return classes.simpleProduct2Row;
            default:
                return  classes.simpleProduct4Row;
        }
    };
    const mdCopyNewlineParse = (copy) => {
        const copyNewLineParsed = copy.replace(/<br>/g, '  \n');
        return copyNewLineParsed;
    };

    return (
        <Grid container className={classes.container}>
            {
                data?.copy ? (
                    <>
                        { data?.banner_image_name && (
                            <Grid className={classes.bannerContainer} item xs={3}>
                                <img className={classes.bannerImage} src={`https://cdn1.1800flowers.com/wcsstore/Flowers/images/banners/radio/personality/${data?.banner_image_name}`} alt={data?.title} aria-hidden />
                            </Grid>
                        )}
                        <Grid className={classes.copyContainer} item xs={8}>
                            <ReactMarkDown source={mdCopyNewlineParse(data.copy)} />
                        </Grid>
                    </>
                ) : (
                    <>
                        { data?.banner_image_name && <Grid item xs={12}><img className={classes.bannerImage} src={`https://cdn1.1800flowers.com/wcsstore/Flowers/images/banners/radio/personality/${data?.banner_image_name}`} alt={data?.title} aria-hidden /></Grid> }
                    </>
                )
            }
            <Grid item className={classes.specialOfferContainer}>
                <div className={classes.specialOfferTitle}>Special Radio Offers</div>
                <SpecialRadioOffers
                    nameFeature={featureCollection?.name}
                    productFeature={featureCollection?.products}
                    productFavorites={listenerFavorites?.products}
                    nameFavorite={listenerFavorites?.name}
                    loadComponent={loadComponent}
                />
            </Grid>
            {showLeftRailContent  && (
                <Grid item className={classes.leftMenu}>
                    <GraphqlLeftMenuContainer
                        classes={{}}
                        contentGNavRef={{}}
                        guidedNavForm={{}}
                        leftMenuData={blocksData}
                        isMobile={false}
                        trackEvent={() => { }}
                        isGuidedNavWidgetEnabledFlag={false}
                        isFacetFiltersCountEnabled={false}
                        setFilterDataInCategoryBuilder={() => { }}
                        productFacetsBase={{}}
                        isFoodBrand={false}
                        isFacetFiltersEnabled={false}
                        filterFlag={{}}
                        category={{}}
                        isFilterFactsV2Enabled={false}
                    />
                </Grid>
            )}
            <Grid container className={showLeftRailContent ? classes.productContainer : ''}>
                <Grid item xs={12} className={classes.bestSellerHeading}>{mainCollection?.name}</Grid>
                {(mainCollection?.products.length > 0 && loadComponent) && mainCollection?.products.map((product) => (
                    <Grid item key={product.name} className={productPerRow(productPerRowDesktop?.products_per_row)}>
                        <RadioOfferProductList product={product} />
                    </Grid>
                ))}
                {data?.modular_blocks?.map((block) => bottomBanner(block))}
            </Grid>
        </Grid>
    );
};

RadioOffersResultDesktopPage.propTypes = {
    mainCollection: shape({
        name: string.isRequired,
        products: array,
    }).isRequired,
    featureCollection: shape({
        name: string.isRequired,
        products: arrayOf(
            shape({
                name: string.isRequired,
                skuPrices: arrayOf(
                    number,
                ).isRequired,
                availability: shape({
                    deliveryMessage: string,
                }),
                image: shape({
                    path: string.isRequired,
                    altText: string,
                    name: string.isRequired,
                }),
                seo: shape({
                    url: string.isRequired,
                }),
            }),
        ),
    }).isRequired,
    listenerFavorites: shape({
        name: string.isRequired,
        products: array,
    }).isRequired,
    data: shape({
        banner_image_name: string,
        title: string,
        modular_blocks: array.isRequired,
    }),
    loadComponent: bool,
    productPerRowDesktop: shape({
        products_per_row: number,
    }),
    bottomBanner: func.isRequired,
    showLeftRailContent: bool.isRequired,
    blocksData: shape({
        pageBlocks: array,
    }),
};

RadioOffersResultDesktopPage.defaultProps = {
    loadComponent: true,
    productPerRowDesktop: {
        products_per_row: 3,
    },
    data: {},
    blocksData: {
        page_blocks: [],
    },
};

export default RadioOffersResultDesktopPage;
